import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import KeenUI from 'keen-ui'
import ui from './ui'
import components from './components'
import Auth from './services/Auth'

import Ckeditor from './ui/ckeditor'

Vue.component('ckeditor', Ckeditor)

Vue.use(VueResource)
Vue.config.productionTip = false

Vue.use(KeenUI)
Vue.use(ui)
Vue.use(components)

Auth.setDefaultHeaders()
const token = Auth.getTokenFromStorage()

if (token) {
  Auth.setTokenForAllRequests(token)
}
/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js